function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "_2-Dashboard_Design-Final-Copy-2",
  "data-name": "2-Dashboard_Design-Final-Copy-2",
  transform: "translate(-31 -322)"
}, /*#__PURE__*/React.createElement("g", {
  id: "shopping-cart-_2_",
  "data-name": "shopping-cart-(2)",
  transform: "translate(31 322)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M15.556,15.556a2.222,2.222,0,1,0,2.222,2.222A2.248,2.248,0,0,0,15.556,15.556Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M19.266,3.2c-.045,0-.112-.022-.18-.022H4.94L4.715,1.7a2,2,0,0,0-2-1.7H.9A.893.893,0,0,0,0,.883a.893.893,0,0,0,.9.883H2.717a.237.237,0,0,1,.225.2L4.334,11.28a2.449,2.449,0,0,0,2.425,2.053H16.1a2.486,2.486,0,0,0,2.425-1.943l1.46-7.174A.874.874,0,0,0,19.266,3.2Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-3",
  "data-name": "Path",
  d: "M8.886,17.681A2.222,2.222,0,1,0,6.677,20h.044A2.245,2.245,0,0,0,8.886,17.681Z"
})));

var SvgStores = function SvgStores(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#fff",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStores, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stores.4adf72fa.svg";
export { ForwardRef as ReactComponent };